import { BaseParser } from '../BaseParser';

/**
 * US Bank Parser
 * Also handles Fidelity (uses same format)
 */
export class USBankParser extends BaseParser {
  constructor() {
    super();
    this.name = 'USBankParser';
    this.priority = 10;
  }

  /**
   * Detect if this is a US Bank or Fidelity CSV file
   */
  detect(header, bank) {
    let confidence = 0;

    // Bank hint
    if (bank === 'usbank' || bank === 'us bank' || bank === 'fidelity') {
      confidence += 50;
    }

    // US Bank format: Date, Transaction, Name, Memo, Amount
    if (header.includes('"date","transaction","name","memo","amount"') ||
        header.includes('date,transaction,name,memo,amount')) {
      confidence += 50;
    }

    return confidence;
  }

  /**
   * Parse US Bank CSV
   * Format: Date, Transaction, Name, Memo, Amount
   * Date format: YYYY-MM-DD
   * Amount: DEBIT transactions are negative, CREDIT are positive
   */
  parse(lines, filename) {
    const transactions = [];

    for (let i = 1; i < lines.length; i++) {
      const line = lines[i];
      if (!line.trim()) continue;

      try {
        const row = this.parseCSVLine(line);
        if (row.length < 5) continue;

        const [date, transactionType, name, memo, amount] = row;
        const amountValue = this.parseAmount(amount);

        // US Bank: DEBIT transactions are negative (expenses), CREDIT are positive (payments/credits)
        // Amount already has correct sign in CSV
        const type = transactionType.toUpperCase() === 'CREDIT' ? 'Credit' : 'Sale';

        transactions.push(this.createTransaction({
          id: this.generateId(date, name, amount),
          date: this.parseDateISO(date),
          postDate: this.parseDateISO(date),
          description: name || 'Unknown',
          amount: amountValue,
          type: type,
          category: 'Uncategorized', // Will be handled by categorization pipeline
          memo: memo || '',
          source: filename || 'US Bank',
          rawData: row
        }));
      } catch (error) {
        this.log(`Error parsing line ${i}: ${error.message}`, 'error');
      }
    }

    return transactions;
  }

  getInfo() {
    return {
      name: this.name,
      priority: this.priority,
      supportedBanks: ['usbank', 'us bank', 'fidelity'],
      formats: ['US Bank', 'Fidelity']
    };
  }
}
